unit Essentials.Web.Manager;

interface

uses
  System.Generics.Collections,
  Data.DB,
  XData.Web.Client,
  XData.Web.Dataset,
  WEBlib.Forms,
  WEBLib.DBCtrls,
  JS,
  Essentials.Shared, Vcl.Controls{,
  Aurelius.Mapping.Explorer};
type
  TLookupMapping = TPair<string, string>;
  TLookupMappings = array of TLookupMapping;

  TEssentialsLookupManager = class
  private
    FWebClient: TXDataWebClient;
    FLookupDataset: TXDataWebDataset;
    FLookupValuesDataset: TXDataWebDataset;
    FComboValuesDataset: TXDataWebDataset;
    FRegisteredEntities: TList<TdtoLookupDef>;
    FCache: TObjectDictionary<string, TList<String>>;
    FLookupValueFilter: string;
    procedure CreateDatasets;
    [Async]
    procedure Load; async;
    [Async]
    procedure LoadLookups; async;
    [Async]
    procedure LoadRegisteredEntities; async;
    procedure ValuesNewRecord(DataSet: TDataSet);
    procedure SetWebClient(const Value: TXDataWebClient);
    function GetRegisteredFields(const AClassName: string): TList<string>;
  public
    constructor Create;
    destructor Destroy; override;
    [Async]
    function SaveLookupChanges: Boolean; async;
    [Async]
    function SaveValueChanges: Boolean; async;
    [Async]
    function LocateLookup(const EntityClassName, FieldName: string): Boolean; async;
    [Async]
    procedure LoadLookupCombos(AForm: TForm); async;
    [Async]
    procedure LoadCombo(ACtrl: TDBComboBox); async;

    class function CacheKey(aEntityClassName, aFieldName: string): string;
    procedure RemoveFromCache(aKey: string);
    procedure UpdateCacheEntry(const aKey, aValue: string; aActivating: Boolean);

    //If the user has unselected a lookup from the dropdown, we want the DB to have [null]
    //and not an empty string. However, webcore gets in the way of this if we do it in the
    //onChange and so it's better to do it as the last validation before saving.
    //This function runs through the lookups on the form and clears the DB where the
    //selection is empty.
    procedure ClearEmptyComboSelections(AForm: TForm);
    property WebClient: TXDataWebClient read FWebClient write SetWebClient;
    property RegisteredEntities: TList<TdtoLookupDef>read FRegisteredEntities;
    property RegisteredFields[const EntityClassName: string]: TList<string>read GetRegisteredFields;
    property LookUpDataset: TXDataWebDataset read FLookupDataset;
    property LookUpValuesDataset: TXDataWebDataset read FLookupValuesDataset;
    property GetFilter: string read FLookupValueFilter;
  end;

  TEssentialsAttributesManager = class
  private
    FWebClient: TXDataWebClient;
    FAttributesDefinitionsDataset: TXDataWebDataset;
    FSelectedEntity: string;
    FRegisteredEntities: TList<TdtoLookupDef>;
    FAttributeDefinitionFilter: string;
    [Async]
    procedure Load; async;
    [Async]
    procedure LoadAttributeDefinitions; async;
    [Async]
    procedure LoadRegisteredEntities; async;
    procedure CreateDatasets;
    procedure SetWebClient(const Value: TXDataWebClient);
    function GetRegisteredFields(const EntityClassName: string): TList<string>;
    procedure DefinitionsNewRecord(Dataset: TDataSet);
  public
    [Async]
    function LocateAttributeDefinitions(const EntityClassName: string): Boolean; async;
    [Async]
    function SaveAttributeDefinitionChanges: Boolean; async;
    constructor Create;
    destructor Destroy; override;
    property WebClient: TXDataWebClient read FWebClient write SetWebClient;
    property RegisteredEntities: TList<TdtoLookupDef>read FRegisteredEntities;
    property RegisteredFields[const EntityClassName: string]: TList<string> read GetRegisteredFields;
    property AttributesDefinitionsDataset: TXDataWebDataset read FAttributesDefinitionsDataset;
    property SelectedEntity: string read FSelectedEntity write FSelectedEntity;
    property GetFilter: string read FAttributeDefinitionFilter;
  end;

  TCustomNamesManager = class
  private
    FWebClient: TXDataWebClient;
    FNamesDataset: TXDataWebDataset;
    FRegisteredEntities: TList<TdtoLookupDef>;
    procedure CreateDataset;
    procedure NamesNewRecord(DataSet: TDataSet);
    [Async]
    procedure LoadRegisteredEntities; async;
    [Async]
    procedure Load; async;
    procedure SetWebClient(const Value: TXDataWebClient);
    function GetRegisteredFields(const EntityClassName: string): TList<string>;
  public
    constructor Create;
    destructor Destroy; override;
    [Async]
    function SaveChanges: Boolean; async;
    [Async]
    procedure SetCustomLabels; async;
    [Async]
    procedure SetCustomTableTitles(const ATable: TDBTableControl); async;
    function EntityCustomName(const EntityClassName: string): string;
    function EntityFieldName(const EntityClassName, FieldName: string): string;
    function HasCustomName(const EntityClassName, FieldName: string; out aCustomName: string): Boolean;
    property WebClient: TXDataWebClient read FWebClient write SetWebClient;
    property NamesDataset: TXDataWebDataset read FNamesDataset write FNamesDataset;
    property RegisteredEntities: TList<TdtoLookupDef>read FRegisteredEntities;
    property RegisteredFields[const EntityClassName: string]: TList<string>read GetRegisteredFields;
  end;

  TNotesManager = class
  private
    FWebClient: TXDataWebClient;
    procedure SetWebClient(const Value: TXDataWebClient);
  public
    [Async]
    function GetNoteData(const ANoteId: Integer): string; async;
    [Async]
    function SaveNoteData(const ANoteId: Integer; const ANote: string): string; async;
    property WebClient: TXDataWebClient read FWebClient write SetWebClient;
  end;

  TEssentialsRequiredFieldsManager = class
  private
    FWebClient: TXDataWebClient;
    FRequiredFieldsDataset: TXDataWebDataset;
    FRegisteredEntities: TList<TdtoLookupDef>;
    FNonDataAwareMappings: TDictionary<string, TPair<string, string>>; // ControlName -> (EntityClassName, FieldName)
    FCache: TDictionary<string, Boolean>; // CacheKey -> IsRequired
    procedure CreateDataset;
    procedure SetWebClient(const Value: TXDataWebClient);
    function GetRegisteredFields(const EntityClassName: string): TList<string>;
    procedure OnNewRecord(Dataset: TDataSet);
    [Async]
    procedure LoadRegisteredEntities; async;
    [Async]
    procedure Load; async;
    [Async]
    procedure SetComponentRequirement(ACtrl: TControl; aEntityClassName, aFieldName: string); async;
  public
    [Async]
    function SaveChanges: Boolean; async;
    constructor Create;
    destructor Destroy; override;
    procedure RegisterNonDataAwareControl(ACtrl: TControl; aEntityClassName, aFieldName: string);
    function IsFieldRequired(const aEntityClassName, aFieldName: string): Boolean;
    function GetNonDataAwareMapping(ACtrl: TControl; out AEntityClassName, AFieldName: string): Boolean;
    function CacheKey(aEntityClassName, aFieldName: string): string;
    procedure RemoveFromCache(aKey: string);
    procedure UpdateCacheEntry(aEntityClassName, aFieldName: string; aActivating: Boolean);
    property WebClient: TXDataWebClient read FWebClient write SetWebClient;
    property RegisteredEntities: TList<TdtoLookupDef> read FRegisteredEntities;
    property RegisteredFields[const EntityClassName: string]: TList<string> read GetRegisteredFields;
    property RequiredFieldsDataset: TXDataWebDataset read FRequiredFieldsDataset write FRequiredFieldsDataset;
  end;

  TEssentialsManager = class
  private
    FWebClient: TXDataWebClient;
    FLookupManager: TEssentialsLookupManager;
    FCustomNamesManager: TCustomNamesManager;
    FNotesManager: TNotesManager;
    FAttributesManager: TEssentialsAttributesManager;
    FRequiredFieldsManager: TEssentialsRequiredFieldsManager;
    FEntitySetMappings: TDictionary<string, string>;
    procedure SetWebClient(const Value: TXDataWebClient);
  public
    constructor Create;
    destructor Destroy; override;
    procedure AddEntitySetMappings(aEntitySetMappings: TLookupMappings);
    [Async]
    procedure FormSetUp(AForm: TForm); async;
    function GetMappedEntitySetName(const AOriginalName: string; out AMappedName: string): Boolean; overload;
    function GetMappedEntitySetName(const AOriginalName, AFieldName: string; out AMappedName: string): Boolean; overload;
    property WebClient: TXDataWebClient read FWebClient write SetWebClient;
    property LookUpManager: TEssentialsLookupManager read FLookupManager;
    property CustomNamesManager: TCustomNamesManager read FCustomNamesManager;
    property NotesManager: TNotesManager read FNotesManager;
    property AttributesManager: TEssentialsAttributesManager read FAttributesManager;
    property RequiredFieldsManager: TEssentialsRequiredFieldsManager read FRequiredFieldsManager;
  end;

implementation

uses
  System.Types,
  System.SysUtils,
  System.Variants,
  XData.Web.JsonDataset,
  SMX.Web.Utils,
  XData.Dataset.Utils,
  SMX.XDataSvc.Utils,
  SMX.Web.Document.Utils, System.TypInfo,
  System.Rtti,
  Systematic.ObjectDictionary.Utils, Web, Essentials.RequiredFields.UtilityUnit,
  Essentials.Web.Shared;


{ TEssentialsManager }

constructor TEssentialsManager.Create;
begin
  FLookupManager := TEssentialsLookupManager.Create;
  FCustomNamesManager := TCustomNamesManager.Create;
  FNotesManager := TNotesManager.Create;
  FAttributesManager := TEssentialsAttributesManager.Create;
  FRequiredFieldsManager := TEssentialsRequiredFieldsManager.Create;
  FEntitySetMappings := TDictionary<string, string>.Create;
end;

destructor TEssentialsManager.Destroy;
begin
  FEntitySetMappings.Free;
  FNotesManager.Free;
  FCustomNamesManager.Free;
  FLookupManager.Free;
  FAttributesManager.Free;
  FRequiredFieldsManager.Free;
  inherited;
end;

procedure TEssentialsManager.AddEntitySetMappings(aEntitySetMappings: TLookupMappings);
var
  mapping: TLookupMapping;
begin
  if aEntitySetMappings <> nil then
  begin
    for mapping in aEntitySetMappings do
      FEntitySetMappings.AddOrSetValue(mapping.Key, mapping.Value);
  end;
end;

function TEssentialsManager.GetMappedEntitySetName(const AOriginalName: string; out AMappedName: string): Boolean;
begin
  // Try to get mapped name from dictionary
  Result := FEntitySetMappings.TryGetValue(AOriginalName, AMappedName);
  // If not found, return original name (but Result will be False)
  if not Result then
    AMappedName := AOriginalName;
end;

function TEssentialsManager.GetMappedEntitySetName(const AOriginalName, AFieldName: string; out AMappedName: string): Boolean;
var
  lFieldKey: string;
begin
  if AFieldName <> '' then
  begin
    lFieldKey := AOriginalName + '.' + AFieldName;
    if FEntitySetMappings.TryGetValue(lFieldKey, AMappedName) then
      Exit(True);
  end;

  Result := GetMappedEntitySetName(AOriginalName, AMappedName);
end;

procedure TEssentialsManager.FormSetUp(AForm: TForm);
var
  I: Integer;
  dataField, entitySetName: string;
begin
  Await(FCustomNamesManager.SetCustomLabels);
  for I := 0 to Aform.ControlCount - 1 do
  begin
    if TRequiredFieldsUtils.HasDataAwareProperties(AForm.controls[I], {o}dataField, {o}entitySetName) then
    begin
      // Use utility function to get mapped name
      GetMappedEntitySetName(entitySetName, dataField, entitySetName);
      Await(FRequiredFieldsManager.SetComponentRequirement(AForm.controls[I], 'T' + entitySetName, dataField));
    end;

    if (AForm.controls[I] is TDBComboBox) then
      Await(FLookupManager.LoadCombo(TDBComboBox(AForm.controls[I])));
    if AForm.Controls[I] is TDBTableControl then
      Await(FCustomNamesManager.SetCustomTableTitles(TDBTableControl(AForm.Controls[I])));
  end;
end;

procedure TEssentialsManager.SetWebClient(const Value: TXDataWebClient);
begin
  FWebClient := Value;
  if Assigned(FWebClient) then
  begin
    FLookupManager.WebClient := FWebClient;
    FNotesManager.WebClient := FWebClient;
    FCustomNamesManager.WebClient := FWebClient;
    FAttributesManager.WebClient := FWebClient;
    FRequiredFieldsManager.WebClient := FWebClient;
  end;
end;

{ TEssentialsLookupManager }

class function TEssentialsLookupManager.CacheKey(aEntityClassName,
  aFieldName: string): string;
begin
  Result := aEntityClassName + '.' + aFieldName;
end;

procedure TEssentialsLookupManager.ClearEmptyComboSelections(AForm: TForm);
var
  I: Integer;
  lEntity, lField: string;
  lCtrl: TControl;
  lCombo: TDBComboBox;
begin
  for I := 0 to AForm.ControlCount - 1 do
  begin
    lCtrl := AForm.Controls[i];
    if lCtrl is TDBComboBox then
    begin
      lCombo := TDBComboBox(lCtrl);
      lField := lCombo.DataField;
      lEntity := 'T' + TXDataWebDataset(lCombo.DataSource.DataSet).EntitySetName;
          {is a populated lookup}                         {has no selection}
      if FCache.ContainsKey(CacheKey(lEntity, lField)) and (lCombo.Text = '') then
      begin
        TXDataWebDataset(TDBComboBox(AForm.controls[I]).DataSource.DataSet).FieldByName(lField).Clear;
        TDBComboBox(lCtrl).ItemIndex := -1;
      end;
    end;
  end;
end;

constructor TEssentialsLookupManager.Create;
begin
  CreateDatasets;
  FCache := TObjectDictionary<string, TList<String>>.Create;
end;

procedure TEssentialsLookupManager.CreateDatasets;
var
  Field: TField;
begin

  if not Assigned(FLookupDataset) then
  begin
    FLookupDataset := TXDataWebDataset.Create(nil);
    FLookupDataset.EntitySetName := 'sxeLookup';

    Field := TIntegerField.Create(FLookupDataset);
    Field.FieldName := 'Id';
    Field.DataSet := FLookupDataset;

    Field := TStringField.Create(FLookupDataset);
    Field.FieldName := 'EntityClassName';
    Field.Size := 64;
    Field.DataSet := FLookupDataset;
    Field.DisplayLabel := 'Entity';

    Field := TStringField.Create(FLookupDataset);
    Field.FieldName := 'FieldName';
    Field.Size := 64;
    Field.DataSet := FLookupDataset;
    Field.DisplayLabel := 'Field';

    Field := TIntegerField.Create(FLookupDataset);
    Field.FieldName := 'AddedBy';
    Field.DataSet := FLookupDataset;

    Field := TIntegerField.Create(FLookupDataset);
    Field.FieldName := 'LastUpdatedBy';
    Field.DataSet := FLookupDataset;

    Field := TDateTimeField.Create(FLookupDataset);
    Field.FieldName := 'DateAdded';
    Field.DataSet := FLookupDataset;

    Field := TDateTimeField.Create(FLookupDataset);
    Field.FieldName := 'LastUpdated';
    Field.DataSet := FLookupDataset;

  end;

  if not Assigned(FLookupValuesDataset) then
  begin
    FLookupValuesDataset := TXDataWebDataset.Create(nil);
    FLookupValuesDataset.EntitySetName := 'sxeLookupValue';

    Field := TIntegerField.Create(FLookupValuesDataset);
    Field.FieldName := 'LookupId';
    Field.Required := True;
    Field.DataSet := FLookupValuesDataset;
    Field.DisplayLabel := 'Lookup Id';

    Field := TStringField.Create(FLookupValuesDataset);
    Field.FieldName := 'LookupValue';
    Field.Size := 64;
    Field.Required := True;
    Field.DataSet := FLookupValuesDataset;
    Field.DisplayLabel := 'Lookup Value';

    Field := TIntegerField.Create(FLookupValuesDataset);
    Field.FieldName := 'SortOrder';
    Field.DataSet := FLookupValuesDataset;
    Field.DisplayLabel := 'Sort Order';

    Field := TStringField.Create(FLookupValuesDataset);
    Field.FieldName := 'Description';
    Field.Size := 255;
    Field.DataSet := FLookupValuesDataset;

    Field := TBooleanField.Create(FLookupValuesDataset);
    Field.FieldName := 'IsActive';
    Field.DataSet := FLookupValuesDataset;
    Field.DefaultExpression := 'True';

    FLookupValuesDataset.OnNewRecord := ValuesNewRecord;
  end;

  if not Assigned(FComboValuesDataset) then
  begin
    FComboValuesDataset := TXDataWebDataset.Create(nil);
    FComboValuesDataset.EntitySetName := 'sxeLookupValue';

    Field := TIntegerField.Create(FComboValuesDataset);
    Field.FieldName := 'LookupId';
    Field.DataSet := FComboValuesDataset;

    Field := TStringField.Create(FComboValuesDataset);
    Field.FieldName := 'LookupValue';
    Field.Size := 64;
    Field.DataSet := FComboValuesDataset;

    Field := TBooleanField.Create(FComboValuesDataset);
    Field.FieldName := 'IsActive';
    Field.DataSet := FComboValuesDataset;
  end;

end;

destructor TEssentialsLookupManager.Destroy;
begin
  if Assigned(FComboValuesDataset) then
  begin
    if FComboValuesDataset.Active then
      FComboValuesDataset.Close;
    FComboValuesDataset.Free;
    FComboValuesDataset := nil;
  end;

  if Assigned(FLookupValuesDataset) then
  begin
    if FLookupValuesDataset.Active then
      FLookupValuesDataset.Close;
    FLookupValuesDataset.Free;
    FLookupValuesDataset := nil;
  end;

  if Assigned(FLookupDataset) then
  begin
    if FLookupDataset.Active then
      FLookupDataset.Close;
    FLookupDataset.Free;
    FLookupDataset := nil;
  end;

  FCache.Free;
  inherited;
end;

function TEssentialsLookupManager.GetRegisteredFields(const AClassName: string): TList<string>;
var
  dto: TdtoLookupDef;
begin
  Result := nil;
  for dto in FRegisteredEntities do
  begin
    if dto.EntityClassName = AClassName then
    begin
      Result := dto.LookupFields;
      break;
    end;
  end;
end;

procedure TEssentialsLookupManager.Load;
begin
  CreateDatasets;
  LoadRegisteredEntities;
  LoadLookups;
end;

procedure TEssentialsLookupManager.LoadCombo(ACtrl: TDBComboBox);
  procedure ProcessItem(aCurrentItem, aSelectedItem: string);
  begin
    ACtrl.Items.Add(aCurrentItem);
    if aCurrentItem = aSelectedItem then
      ACtrl.ItemIndex := ACtrl.Items.Count - 1;
  end;
var {LoadCombo}
  lField, lEntity, lSelectedItem, lCurrentItem, lKey, lEntitySetName: string;
  lItems: TList<string>;
  Info: TResolveResults;
begin
  lField := ACtrl.DataField;
  lEntitySetName := TXDataWebDataset(ACtrl.DataSource.DataSet).EntitySetName;

  // Use EssentialsManager to get mapped entity set name
  // Note: This requires EssentialsManager to be accessible, which it should be via Essentials.Web.Shared
  if Assigned(EssentialsManager) then
    EssentialsManager.GetMappedEntitySetName(lEntitySetName, lField, lEntitySetName);

  lEntity := 'T' + lEntitySetName;
  if TXDataWebDataset(ACtrl.DataSource.DataSet).Active then
    lSelectedItem := TXDataWebDataset(ACtrl.DataSource.DataSet).FieldByName(lField).AsString;
  lKey := lEntity + '.' + lField;
  ACtrl.Items.Clear;
  ACtrl.Items.Add('');

  if FCache.ContainsKey(lKey) then
  begin
    lItems := FCache[lKey];
    for lCurrentItem in lItems do
      ProcessItem(lCurrentItem, lSelectedItem);
  end
  else
  begin
    if Await(LocateLookup(lEntity, lField)) then
    begin
      FComboValuesDataset.Close;
      FComboValuesDataset.QueryString := '$filter=' + FLookupValueFilter + ' & $orderby=SortOrder asc';
      Info := Await(TResolveResults, FComboValuesDataset.LoadAsync);
      FComboValuesDataset.First;
      while not FComboValuesDataset.Eof do
      begin
        if FComboValuesDataset.FieldByName('IsActive').AsBoolean then
        begin
          lCurrentItem := FComboValuesDataset.FieldByName('LookupValue').AsString;
          TObDictUtils<string, string>.Add(lKey, lCurrentItem, FCache);
          ProcessItem(lCurrentItem, lSelectedItem);
        end;
        FComboValuesDataset.Next;
      end;
    end;
  end;

  if (lSelectedItem <> '') and (ACtrl.Items.IndexOf(lSelectedItem) = -1) then
  begin
    ACtrl.Items.Add(lSelectedItem);
    ACtrl.ItemIndex := ACtrl.Items.Count - 1;
  end;
end;

procedure TEssentialsLookupManager.LoadLookups;
begin
  Await(FLookupDataset.LoadAsync);
end;

procedure TEssentialsLookupManager.LoadRegisteredEntities;
const
  essentials_svc = 'IEssentialsService.SupportedLookupEntities';
var
  lRetval: TXDataClientResponse;
  lArray: TJSArray;
  lObject: TJSObject;
  I: Integer;
  LList: TList<TdtoLookupDef>;
  lDef: TdtoLookupDef;
begin
  lRetval := Await(TXDataClientResponse, FWebClient.RawInvokeAsync(essentials_svc, []));
  lArray := TXDataSvcUtils.AsArray(lRetval);

  LList := TList<TdtoLookupDef>.Create;
  try
    for I := 0 to lArray.Length - 1 do
    begin
      lDef := TdtoLookupDef.CreateFromJSON(lArray[I]);
      LList.Add(lDef);
    end;

    if Assigned(FRegisteredEntities) then
      FRegisteredEntities.Free;
    FRegisteredEntities := LList;
  except
    LList.Free;
    raise;
  end;
end;

function TEssentialsLookupManager.LocateLookup(const EntityClassName, FieldName: string): Boolean;
var
  V: TJSValueDynArray;
begin

  if (FLookupDataset.FieldByName('EntityClassName').AsString.ToUpper = EntityClassName.ToUpper) and
    (FLookupDataset.FieldByName('FieldName').AsString.ToUpper = FieldName.ToUpper) then
  begin
    FLookupValueFilter := 'LookupId eq ' + FLookupDataset.FieldByName('Id').AsString;
    Exit(True);
  end;

  SetLength(V, 2);

  V[0] := EntityClassName;
  V[1] := FieldName;

  Result := FLookupDataset.Locate('EntityClassName;FieldName', V, [loCaseInsensitive]);
  if not Result then
  begin
    FLookupDataset.Insert;
    FLookupDataset.FieldByName('EntityClassName').AsString := EntityClassName;
    FLookupDataset.FieldByName('FieldName').AsString := FieldName;
    FLookupDataset.FieldByName('DateAdded').AsDateTime := Now;
    FLookupDataset.Post;
    Await(SaveLookupChanges);
    Result := True;
  end;

  FLookupValueFilter := 'LookupId eq ' + FLookupDataset.FieldByName('Id').AsString;
end;

procedure TEssentialsLookupManager.RemoveFromCache(aKey: string);
begin
  FCache.Remove(aKey);
end;

procedure TEssentialsLookupManager.UpdateCacheEntry(const aKey, aValue: string; aActivating: Boolean);
var
  lItems: TList<string>;
begin
  if not FCache.TryGetValue(aKey, lItems) then
    Exit;

  if aActivating then
  begin
    if lItems.IndexOf(aValue) = -1 then
      lItems.Add(aValue);
  end
  else
    lItems.Remove(aValue);
end;

function TEssentialsLookupManager.SaveLookupChanges: Boolean;
var
  Info: TResolveResults;
begin
  if TXDataDSUtils.CheckIsModified(FLookupDataset) then
  begin
    Info := Await(FLookupDataset.ApplyUpdatesAsync);
    { TODO : Check for errors }

    TXDataDSUtils.UpdateAllIds(FLookupDataset, Info, 'Id');
    Result := True;
  end
  else
    Result := True;
end;

function TEssentialsLookupManager.SaveValueChanges: Boolean;
var
  Info: TResolveResults;
begin
  if TXDataDSUtils.CheckIsModified(FLookupValuesDataset) then
  begin
    Info := Await(FLookupValuesDataset.ApplyUpdatesAsync);
    { TODO : Check for errors }
    Result := True;
  end
  else
    Result := True;
end;

procedure TEssentialsLookupManager.LoadLookupCombos(AForm: TForm);
var
  I: Integer;
  C, S: string;
begin
  for I := 0 to Aform.ControlCount - 1 do
  begin
    C := AForm.controls[I].ClassName;
    S := AForm.controls[I].Name;
    if (AForm.controls[I] is TDBComboBox) then
      LoadCombo(TDBComboBox(AForm.controls[I]));
  end;
end;

procedure TEssentialsLookupManager.SetWebClient(const Value: TXDataWebClient);
begin
  FWebClient := Value;
  FLookupDataset.Connection := FWebClient.Connection;
  FLookupValuesDataset.Connection := FWebClient.Connection;
  FComboValuesDataset.Connection := FWebClient.Connection;
  Load;
end;

procedure TEssentialsLookupManager.ValuesNewRecord(DataSet: TDataSet);
begin
  FLookupValuesDataset.FieldByName('LookupId').AsInteger := FLookupDataset.FieldByName('Id').AsInteger;
  FLookupValuesDataset.FieldByName('IsActive').AsBoolean := True;
end;

{ TCustomNamesManager }

constructor TCustomNamesManager.Create;
begin
  CreateDataset;
end;

procedure TCustomNamesManager.CreateDataset;
var
  Field: TField;
begin
  if not Assigned(FNamesDataset) then
  begin
    FNamesDataset := TXDataWebDataset.Create(nil);
    FNamesDataset.EntitySetName := 'sxeCustomName';

    Field := TIntegerField.Create(FNamesDataset);
    Field.FieldName := 'Id';
    Field.DataSet := FNamesDataset;

    Field := TStringField.Create(FNamesDataset);
    Field.FieldName := 'EntityClassName';
    Field.Size := 64;
    Field.DataSet := FNamesDataset;
    Field.DisplayLabel := 'Entity';
    Field.Required := True;

    Field := TStringField.Create(FNamesDataset);
    Field.FieldName := 'FieldName';
    Field.Size := 64;
    Field.DataSet := FNamesDataset;
    Field.DisplayLabel := 'Field';
    Field.Required := True;

    Field := TStringField.Create(FNamesDataset);
    Field.FieldName := 'CustomName';
    Field.Size := 64;
    Field.DataSet := FNamesDataset;
    Field.DisplayLabel := 'CustomName';
    Field.Required := True;

    Field := TBooleanField.Create(FNamesDataset);
    Field.FieldName := 'IsActive';
    Field.DataSet := FNamesDataset;
    Field.DefaultExpression := 'True';

    Field := TIntegerField.Create(FNamesDataset);
    Field.FieldName := 'AddedBy';
    Field.DataSet := FNamesDataset;

    Field := TIntegerField.Create(FNamesDataset);
    Field.FieldName := 'LastUpdatedBy';
    Field.DataSet := FNamesDataset;

    Field := TDateTimeField.Create(FNamesDataset);
    Field.FieldName := 'DateAdded';
    Field.DataSet := FNamesDataset;

    Field := TDateTimeField.Create(FNamesDataset);
    Field.FieldName := 'LastUpdated';
    Field.DataSet := FNamesDataset;

    FNamesDataset.OnNewRecord := NamesNewRecord;
  end;

end;

procedure TCustomNamesManager.NamesNewRecord(DataSet: TDataSet);
begin
  DataSet.FieldByName('EntityClassName').Clear;
  DataSet.FieldByName('FieldName').Clear;
  DataSet.FieldByName('CustomName').Clear;
  DataSet.FieldByName('DateAdded').AsDateTime := Now;
  DataSet.FieldByName('LastUpdated').Clear;
  DataSet.FieldByName('LastUpdatedBy').Clear;
  DataSet.FieldByName('AddedBy').Clear;
  DataSet.FieldByName('IsActive').AsBoolean := True;
end;

destructor TCustomNamesManager.Destroy;
begin
  if Assigned(FNamesDataset) then
  begin
    if FNamesDataset.Active then
      FNamesDataset.Close;
    FNamesDataset.Free;
    FNamesDataset := nil;
  end;

  inherited;
end;

function TCustomNamesManager.EntityCustomName(const EntityClassName: string): string;
begin
  Result := EntityFieldName(EntityClassName, 'Self');
  if Result = '' then
    Result := TUtils.SplitOnCaps(EntityClassName.Substring(1));
end;

function TCustomNamesManager.EntityFieldName(const EntityClassName, FieldName: string): string;
begin
  Result := '';
  FNamesDataset.First;
  while not FNamesDataset.Eof do
  begin
    if FNamesDataset.FieldByName('IsActive').AsBoolean and
       SameText(FNamesDataset.FieldByName('EntityClassName').AsString, EntityClassName) and
       SameText(FNamesDataset.FieldByName('FieldName').AsString, FieldName) then
      Exit(FNamesDataset.FieldByName('CustomName').AsString);
    FNamesDataset.Next;
  end;
end;

function TCustomNamesManager.GetRegisteredFields(const EntityClassName: string): TList<string>;
var
  dto: TdtoLookupDef;
begin
  Result := nil;
  for dto in FRegisteredEntities do
  begin
    if dto.EntityClassName = EntityClassName then
    begin
      Result := dto.LookupFields;
      break;
    end;
  end;
end;

function TCustomNamesManager.HasCustomName(const EntityClassName,
  FieldName: string; out aCustomName: string): Boolean;
begin
  aCustomName := EntityFieldName(EntityClassName, FieldName);
  Result := aCustomName <> '';
end;

procedure TCustomNamesManager.Load;
begin
  Await(LoadRegisteredEntities);
  Await(FNamesDataset.LoadAsync);
end;

procedure TCustomNamesManager.LoadRegisteredEntities;
const
  essentials_svc = 'IEssentialsService.SupportedCustomNamesEntities';
var
  lRetval: TXDataClientResponse;
  lArray: TJSArray;
  lObject: TJSObject;
  I: Integer;
  LList: TList<TdtoLookupDef>;
  lDef: TdtoLookupDef;
begin
  lRetval := Await(TXDataClientResponse, FWebClient.RawInvokeAsync(essentials_svc, []));
  lArray := TXDataSvcUtils.AsArray(lRetval);

  LList := TList<TdtoLookupDef>.Create;
  try
    for I := 0 to lArray.Length - 1 do
    begin
      lDef := TdtoLookupDef.CreateFromJSON(lArray[I]);
      LList.Add(lDef);
    end;

    if Assigned(FRegisteredEntities) then
      FRegisteredEntities.Free;
    FRegisteredEntities := LList;
  except
    LList.Free;
    raise;
  end;
end;

function TCustomNamesManager.SaveChanges: Boolean;
var
  Info: TResolveResults;
begin
  if TXDataDSUtils.CheckIsModified(FNamesDataset) then
  begin
    Info := Await(FNamesDataset.ApplyUpdatesAsync);
    { TODO : Check for errors }
    TXDataDSUtils.UpdateAllIds(FNamesDataset, Info, 'Id');
    Result := True;
  end
  else
    Result := True;
end;

procedure TCustomNamesManager.SetCustomLabels;
var
  elId: string;
begin
  FNamesDataset.First;
  while not FNamesDataset.Eof do
  begin
    if FNamesDataset.FieldByName('IsActive').AsBoolean then
    begin
      elId :=
        FNamesDataset.FieldByName('EntityClassName').AsString.Substring(1).ToLower + '.' +
        FNamesDataset.FieldByName('FieldName').AsString.ToLower + '.label';

      if TDocUtils.elementIdExists(elId) then
        TDocUtils.writeElementText(elId, FNamesDataset.FieldByName('CustomName').AsString);
    end;

    FNamesDataset.Next;
  end;
end;

procedure TCustomNamesManager.SetCustomTableTitles(const ATable: TDBTableControl);
var
  lClassName: string;
  lRegisteredFields: TList<string>;
  S: string;
  I: Integer;
begin
  lClassName := 'T' + TXDataWebDataset(ATable.DataSource.DataSet).EntitySetName;
  lRegisteredFields := GetRegisteredFields(lClassName);
  if not Assigned(lRegisteredFields) then
    Exit;

  for I := 0 to ATable.Columns.Count - 1 do
  begin
    S := EntityFieldName(lClassName, ATable.Columns[I].DataField);
    if S <> '' then
      ATable.Columns[I].Title := S;
  end;

end;

procedure TCustomNamesManager.SetWebClient(const Value: TXDataWebClient);
begin
  FWebClient := Value;
  FNamesDataset.Connection := FWebClient.Connection;
  Load;
end;

{ TNotesManager }

function TNotesManager.GetNoteData(const ANoteId: Integer): string;
const
  essentials_svc = 'IEssentialsService.GetNote';
var
  lRetval: TXDataClientResponse;
begin
  lRetval := Await(TXDataClientResponse, FWebClient.RawInvokeAsync(essentials_svc, [ANoteId]));
  Result := TXDataSvcUtils.AsString(lRetval);
end;

function TNotesManager.SaveNoteData(const ANoteId: Integer; const ANote: string): string;
const
  essentials_svc = 'IEssentialsService.SaveNote';
var
  lRetval: TXDataClientResponse;
begin
  lRetval := Await(TXDataClientResponse, FWebClient.RawInvokeAsync(essentials_svc, [ANoteId, ANote]));
  Result := TXDataSvcUtils.AsString(lRetval);
end;

procedure TNotesManager.SetWebClient(const Value: TXDataWebClient);
begin
  FWebClient := Value;
end;

{ TEssentialsAttributesManager }

constructor TEssentialsAttributesManager.Create;
begin
  CreateDatasets;
  //insert into DATA_ATTRIBUTE_DEF (Id, DATE_ADDED, ADDED_BY, LAST_UPDATED, LAST_UPDATED_BY, ENTITY_NAME, NAME, VALUE_KIND, MULTI_VALUE) Values (0, datetime('now'), 1, datetime('now'), 1, "EssentialsDemo1", "Phone", "Text", "T")
end;

procedure TEssentialsAttributesManager.CreateDatasets;
var
  field: TField;
begin
  if not Assigned(FAttributesDefinitionsDataset) then
  begin
    FAttributesDefinitionsDataset := TXDataWebDataset.Create(nil);
    FAttributesDefinitionsDataset.EntitySetName := 'sxeDataAttributeDef';

    Field := TIntegerField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'Id';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TStringField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'Name';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TStringField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'EntityName';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TStringField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'ValueKind';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TBooleanField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'MultiValue';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TIntegerField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'AddedBy';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TIntegerField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'LastUpdatedBy';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TDateTimeField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'DateAdded';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TDateTimeField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'LastUpdated';
    Field.DataSet := FAttributesDefinitionsDataset;

    Field := TBooleanField.Create(FAttributesDefinitionsDataset);
    Field.FieldName := 'IsActive';
    Field.DataSet := FAttributesDefinitionsDataset;
    Field.DefaultExpression := 'True';

    FAttributesDefinitionsDataset.OnNewRecord := DefinitionsNewRecord;
  end;
end;

destructor TEssentialsAttributesManager.Destroy;
begin

  if Assigned(FAttributesDefinitionsDataset) then
  begin
    if FAttributesDefinitionsDataset.Active then
      FAttributesDefinitionsDataset.Close;
    FAttributesDefinitionsDataset.Free;
    FAttributesDefinitionsDataset := nil;
  end;

  inherited;
end;

function TEssentialsAttributesManager.GetRegisteredFields(
  const EntityClassName: string): TList<string>;
var
  dto: TdtoLookupDef;
begin
  Result := nil;
  for dto in FRegisteredEntities do
  begin
    if dto.EntityClassName = EntityClassName then
    begin
      Result := dto.LookupFields;
      break;
    end;
  end;
end;

procedure TEssentialsAttributesManager.Load;
begin
  CreateDatasets;
  Await(LoadRegisteredEntities);
end;

procedure TEssentialsAttributesManager.LoadAttributeDefinitions;
var
  Info: TResolveResults;
begin
  FAttributeDefinitionFilter := 'EntityName eq ' + QuotedStr(FSelectedEntity);
  FAttributesDefinitionsDataset.QueryString := '$filter=' + FAttributeDefinitionFilter;
  Info := Await(TResolveResults, FAttributesDefinitionsDataset.LoadAsync);
end;

procedure TEssentialsAttributesManager.LoadRegisteredEntities;
const
  essentials_svc = 'IEssentialsService.SupportedAttributeEntities';
var
  lRetval: TXDataClientResponse;
  lArray: TJSArray;
  lObject: TJSObject;
  I: Integer;
  LList: TList<TdtoLookupDef>;
  lDef: TdtoLookupDef;
begin
  lRetval := Await(TXDataClientResponse, FWebClient.RawInvokeAsync(essentials_svc, []));
  lArray := TXDataSvcUtils.AsArray(lRetval);

  LList := TList<TdtoLookupDef>.Create;
  try
    for I := 0 to lArray.Length - 1 do
    begin
      lDef := TdtoLookupDef.CreateFromJSON(lArray[I]);
      LList.Add(lDef);
    end;

    if Assigned(FRegisteredEntities) then
      FRegisteredEntities.Free;
    FRegisteredEntities := LList;
  except
    LList.Free;
    raise;
  end;
end;


function TEssentialsAttributesManager.LocateAttributeDefinitions(const EntityClassName: string): Boolean;
var
  V: TJSValueDynArray;
begin
  if (FSelectedEntity <> '') and (FSelectedEntity.ToUpper = EntityClassName.ToUpper) then
  begin
    Await(LoadAttributeDefinitions);
    Exit(True);
  end;

  FAttributesDefinitionsDataset.Close;

  Await(LoadAttributeDefinitions);
  SetLength(V, 1);
  V[0] := EntityClassName;
  Result := FAttributesDefinitionsDataset.Locate('EntityName', V, [loCaseInsensitive]);
end;

function TEssentialsAttributesManager.SaveAttributeDefinitionChanges: Boolean;
var
  Info: TResolveResults;
begin
  if TXDataDSUtils.CheckIsModified(FAttributesDefinitionsDataset) then
  begin
    Info := Await(FAttributesDefinitionsDataset.ApplyUpdatesAsync);
    { TODO : Check for errors }
    TXDataDSUtils.UpdateAllIds(FAttributesDefinitionsDataset, Info, 'Id');
    Result := True;
  end
  else
    Result := True;
end;

procedure TEssentialsAttributesManager.SetWebClient(const Value: TXDataWebClient);
begin
  FWebClient := Value;
  FAttributesDefinitionsDataset.Connection := FWebClient.Connection;
  Load;
end;

procedure TEssentialsAttributesManager.DefinitionsNewRecord(Dataset: TDataSet);
begin
  FAttributesDefinitionsDataset.FieldByName('EntityName').AsString := FSelectedEntity;
  FAttributesDefinitionsDataset.FieldByName('DateAdded').AsDateTime := Now;
  FAttributesDefinitionsDataset.FieldByName('LastUpdated').AsDateTime := Now;
  FAttributesDefinitionsDataset.FieldByName('IsActive').AsBoolean := True;
end;

{ TEssentialsRequiredFieldsManager }

constructor TEssentialsRequiredFieldsManager.Create;
begin
  CreateDataset;
  FNonDataAwareMappings := TDictionary<string, TPair<string, string>>.Create;
  FCache := TDictionary<string, Boolean>.Create;
end;

procedure TEssentialsRequiredFieldsManager.CreateDataset;
var
  field: TField;
begin
  if not Assigned(FRequiredFieldsDataset) then
  begin
    FRequiredFieldsDataset := TXDataWebDataset.Create(nil);
    FRequiredFieldsDataset.EntitySetName := 'sxeRequiredField';

    Field := TIntegerField.Create(FRequiredFieldsDataset);
    Field.FieldName := 'Id';
    Field.DataSet := FRequiredFieldsDataset;

    Field := TStringField.Create(FRequiredFieldsDataset);
    Field.FieldName := 'EntityClassName';
    Field.DataSet := FRequiredFieldsDataset;

    Field := TStringField.Create(FRequiredFieldsDataset);
    Field.FieldName := 'FieldName';
    Field.DataSet := FRequiredFieldsDataset;

    Field := TIntegerField.Create(FRequiredFieldsDataset);
    Field.FieldName := 'AddedBy';
    Field.DataSet := FRequiredFieldsDataset;

    Field := TIntegerField.Create(FRequiredFieldsDataset);
    Field.FieldName := 'LastUpdatedBy';
    Field.DataSet := FRequiredFieldsDataset;

    Field := TDateTimeField.Create(FRequiredFieldsDataset);
    Field.FieldName := 'DateAdded';
    Field.DataSet := FRequiredFieldsDataset;

    Field := TDateTimeField.Create(FRequiredFieldsDataset);
    Field.FieldName := 'LastUpdated';
    Field.DataSet := FRequiredFieldsDataset;

    Field := TBooleanField.Create(FRequiredFieldsDataset);
    Field.FieldName := 'IsActive';
    Field.DataSet := FRequiredFieldsDataset;
    Field.DefaultExpression := 'True';

    FRequiredFieldsDataset.OnNewRecord := OnNewRecord;
  end;
end;

destructor TEssentialsRequiredFieldsManager.Destroy;
begin
  if Assigned(FRequiredFieldsDataset) then
  begin
    if FRequiredFieldsDataset.Active then
      FRequiredFieldsDataset.Close;
    FRequiredFieldsDataset.Free;
    FRequiredFieldsDataset := nil;
  end;
  FCache.Free;
  FNonDataAwareMappings.Free;
  inherited;
end;

function TEssentialsRequiredFieldsManager.GetRegisteredFields(const EntityClassName: string): TList<string>;
var
  dto: TdtoLookupDef;
begin
  Result := nil;
  for dto in FRegisteredEntities do
  begin
    if dto.EntityClassName = EntityClassName then
    begin
      Result := dto.LookupFields;
      break;
    end;
  end;
end;

procedure TEssentialsRequiredFieldsManager.Load;
begin
  Await(LoadRegisteredEntities);
  Await(FRequiredFieldsDataset.LoadAsync);
end;

procedure TEssentialsRequiredFieldsManager.LoadRegisteredEntities;
const
  essentials_svc = 'IEssentialsService.SupportedRequiredFieldsEntities';
var
  lRetval: TXDataClientResponse;
  lArray: TJSArray;
  lObject: TJSObject;
  I: Integer;
  LList: TList<TdtoLookupDef>;
  lDef: TdtoLookupDef;
begin
  lRetval := Await(TXDataClientResponse, FWebClient.RawInvokeAsync(essentials_svc, []));
  lArray := TXDataSvcUtils.AsArray(lRetval);

  LList := TList<TdtoLookupDef>.Create;
  try
    for I := 0 to lArray.Length - 1 do
    begin
      lDef := TdtoLookupDef.CreateFromJSON(lArray[I]);
      LList.Add(lDef);
    end;

    if Assigned(FRegisteredEntities) then
      FRegisteredEntities.Free;
    FRegisteredEntities := LList;
  except
    LList.Free;
    raise;
  end;
end;

procedure TEssentialsRequiredFieldsManager.OnNewRecord(Dataset: TDataSet);
begin
  FRequiredFieldsDataset.FieldByName('DateAdded').AsDateTime := Now;
  FRequiredFieldsDataset.FieldByName('LastUpdated').AsDateTime := Now;
  FRequiredFieldsDataset.FieldByName('IsActive').AsBoolean := True;
end;

function TEssentialsRequiredFieldsManager.SaveChanges: Boolean;
var
  Info: TResolveResults;
begin
  // Ensure dataset is active and has connection
  if not Assigned(FRequiredFieldsDataset) then
    Exit(False);
    
  if not FRequiredFieldsDataset.Active then
    Exit(False);
    
  // Ensure dataset is posted if in edit/insert mode
  if FRequiredFieldsDataset.State in dsEditModes then
    FRequiredFieldsDataset.Post;
    
  if TXDataDSUtils.CheckIsModified(FRequiredFieldsDataset) then
  begin
    Info := Await(FRequiredFieldsDataset.ApplyUpdatesAsync);
    { TODO : Check for errors }
    TXDataDSUtils.UpdateAllIds(FRequiredFieldsDataset, Info, 'Id');
    
    // Clear cache when changes are saved to ensure fresh data
    FCache.Clear;
    
    Result := True;
  end
  else
    Result := True;
end;

procedure TEssentialsRequiredFieldsManager.SetComponentRequirement(ACtrl: TControl; aEntityClassName, aFieldName: string);
var
  V: TJSValueDynArray;
  IsRequired: Boolean;
  FoundInCache: Boolean;
begin
  // This method works for both data-aware and non-data-aware controls
  // It checks the database to see if the field is required and sets the Required property accordingly
  if (ACtrl = nil) or (aEntityClassName = '') or (aFieldName = '') then
    Exit;
    
  // Check cache first to avoid expensive Locate calls
  FoundInCache := FCache.TryGetValue(CacheKey(aEntityClassName, aFieldName), IsRequired);

  if not FoundInCache then
  begin
    // Not in cache, do Locate and cache the result
    SetLength(V, 2);
    V[0] := aEntityClassName;
    V[1] := aFieldName;
    IsRequired := FRequiredFieldsDataset.Locate('EntityClassName;FieldName', V, [loCaseInsensitive]) and
      FRequiredFieldsDataset.FieldByName('IsActive').AsBoolean;
    
    // Cache the result (True if found, False if not found)
    FCache.AddOrSetValue(CacheKey(aEntityClassName, aFieldName), IsRequired);
  end;
  
  // Apply required-field UI setup if the field is required
  if IsRequired then
  begin
    TRequiredFieldsUtils.MarkRequiredFieldLabel(ACtrl, aEntityClassName);
    TRequiredFieldsUtils.SetupRequiredFieldValidityForControl(ACtrl);
  end;
end;

procedure TEssentialsRequiredFieldsManager.RegisterNonDataAwareControl(ACtrl: TControl; aEntityClassName, aFieldName: string);
var
  lemons: integer;
begin
  if ACtrl <> nil then
  begin

    if aCtrl.Name = 'Add2Edit' then
      lemons := 123;
    // Store the mapping for later retrieval during validation
    FNonDataAwareMappings.AddOrSetValue(ACtrl.Name, TPair<string, string>.Create(aEntityClassName, aFieldName));
    
    // Also check if this field is required in the database and apply required-field UI setup
    SetComponentRequirement(ACtrl, aEntityClassName, aFieldName);
  end;
end;

function TEssentialsRequiredFieldsManager.IsFieldRequired(const aEntityClassName, aFieldName: string): Boolean;
var
  V: TJSValueDynArray;
  FoundInCache: Boolean;
begin
  Result := False;
  if (aEntityClassName = '') or (aFieldName = '') then
    Exit;

  if not Assigned(FRequiredFieldsDataset) or (not FRequiredFieldsDataset.Active) then
    Exit;

  FoundInCache := FCache.TryGetValue(CacheKey(aEntityClassName, aFieldName), Result);
  if FoundInCache then
    Exit;

  SetLength(V, 2);
  V[0] := aEntityClassName;
  V[1] := aFieldName;
  Result := FRequiredFieldsDataset.Locate('EntityClassName;FieldName', V, [loCaseInsensitive]) and
    FRequiredFieldsDataset.FieldByName('IsActive').AsBoolean;
  FCache.AddOrSetValue(CacheKey(aEntityClassName, aFieldName), Result);
end;

function TEssentialsRequiredFieldsManager.GetNonDataAwareMapping(ACtrl: TControl; out AEntityClassName, AFieldName: string): Boolean;
var
  Mapping: TPair<string, string>;
begin
  Result := False;
  AEntityClassName := '';
  AFieldName := '';
  
  if (ACtrl <> nil) and FNonDataAwareMappings.TryGetValue(ACtrl.Name, Mapping) then
  begin
    AEntityClassName := Mapping.Key;
    AFieldName := Mapping.Value;
    Result := True;
  end;
end;

function TEssentialsRequiredFieldsManager.CacheKey(aEntityClassName, aFieldName: string): string;
begin
  Result := aEntityClassName + '.' + aFieldName;
end;

procedure TEssentialsRequiredFieldsManager.RemoveFromCache(aKey: string);
begin
  FCache.Remove(aKey);
end;

procedure TEssentialsRequiredFieldsManager.UpdateCacheEntry(aEntityClassName, aFieldName: string; aActivating: Boolean);
begin
  FCache.AddOrSetValue(CacheKey(aEntityClassName, aFieldName), aActivating);
end;

procedure TEssentialsRequiredFieldsManager.SetWebClient(
  const Value: TXDataWebClient);
begin
  FWebClient := Value;
  FRequiredFieldsDataset.Connection := FWebClient.Connection;
  Load;
end;

end.

